import { Card, Typography } from "antd";
import Chart from "react-apexcharts";
import React from "react";

export default function PaymentMethod() {
  // Chart data
  const series = [24, 32, 34]; // Recurring: 24%, Others: 76%

  const options = {
    chart: {
      type: "donut",
      height: 250,
    },
    labels: ["Recurring", "Others"],
    colors: ["#E0DDF7", "#AD9EE7", "#6B43B5"], // Purple for Recurring, light gray for Others
    legend: { show: false },
    dataLabels: { enabled: false },
    plotOptions: {
      pie: {
        startAngle: -90,
        endAngle: 270,
        donut: {
          size: "85%",
          labels: {
            show: true,
            // name: { show: false },
            value: { show: true, color: "#979797", fontSize: "16px", offsetY: -5 },
            total: {
              show: true,
              showAlways: true,
              label: "Payment Method",
              color: "#979797",
              fontSize: "16px",
              fontWeight: 400,
              formatter: () => "Distribution",
            },
          },
        },
      },
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: function (val) {
          return val + "%";
        },
      },
    },
    states: {
      hover: {
        filter: {
          type: "none",
        },
      },
      active: {
        filter: {
          type: "none",
        },
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            height: 240,
          },
        },
      },
    ],
  };

  return (
    <Card>
      <Typography.Title level={4}>Payment Method</Typography.Title>
      <Chart options={options} series={series} type="donut" height={260} />
    </Card>
  );
}
